import { getLimitPlanUpperLimit as getModernSubscriptionLimitPlanUpperLimit } from '../internal/modernSubscription/getLimitPlanUpperLimit';
import type { LimitPlan } from '../types';

export function getLimitPlanUpperLimit(limitPlan: LimitPlan) {
  return getModernSubscriptionLimitPlanUpperLimit(limitPlan);
  // not supported for legacy subscriptions
}
